var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beef-tooltip fantastic-chart--tooltip"},_vm._l((_vm.users),function(user){return _c('deq-user',{key:user.id,attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }